import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../constants";
const ItemAttributeQuery = graphql(`
  query ItemAttributeQuery(
    $traitType: String!
    $value: String!
    $collectionId: String!
  ) {
    itemAttribute(
      attribute: {
        traitType: $traitType
        value: $value
        collectionId: $collectionId
      }
    ) {
      traitType
      value
      floorPrice {
        token {
          unit
        }
      }
      topOfferPrice {
        token {
          unit
        }
      }
    }
  }
`);
export function useItemAttribute(t0) {
  const $ = _c(11);
  const {
    traitType,
    value,
    collectionId,
    pause
  } = t0;
  let t1;
  if ($[0] !== collectionId || $[1] !== traitType || $[2] !== value) {
    t1 = {
      traitType,
      value,
      collectionId
    };
    $[0] = collectionId;
    $[1] = traitType;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pause || $[5] !== t1) {
    t2 = {
      query: ItemAttributeQuery,
      variables: t1,
      pause,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[4] = pause;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [t3] = useQuery(t2);
  const {
    data,
    fetching,
    error
  } = t3;
  const t4 = data?.itemAttribute;
  let t5;
  if ($[7] !== error || $[8] !== fetching || $[9] !== t4) {
    t5 = {
      attribute: t4,
      fetching,
      error
    };
    $[7] = error;
    $[8] = fetching;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export function useItemAttributes(t0) {
  const $ = _c(24);
  const {
    traits,
    collectionId,
    pause
  } = t0;
  const shouldPause = pause || traits.length === 0;
  const t1 = traits[0]?.traitType || "";
  const t2 = traits[0]?.value || "";
  let t3;
  if ($[0] !== collectionId || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      traitType: t1,
      value: t2,
      collectionId
    };
    $[0] = collectionId;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = shouldPause || traits.length < 1;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      query: ItemAttributeQuery,
      variables: t3,
      pause: t4,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const [t6] = useQuery(t5);
  const {
    data: trait1Data,
    fetching: trait1Fetching,
    error: trait1Error
  } = t6;
  const t7 = traits[1]?.traitType || "";
  const t8 = traits[1]?.value || "";
  let t9;
  if ($[7] !== collectionId || $[8] !== t7 || $[9] !== t8) {
    t9 = {
      traitType: t7,
      value: t8,
      collectionId
    };
    $[7] = collectionId;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = shouldPause || traits.length < 2;
  let t11;
  if ($[11] !== t10 || $[12] !== t9) {
    t11 = {
      query: ItemAttributeQuery,
      variables: t9,
      pause: t10,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const [t12] = useQuery(t11);
  const {
    data: trait2Data,
    fetching: trait2Fetching,
    error: trait2Error
  } = t12;
  const t13 = trait1Data?.itemAttribute;
  const t14 = trait2Data?.itemAttribute;
  let t15;
  if ($[14] !== t13 || $[15] !== t14) {
    t15 = [t13, t14].filter(Boolean);
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const attributes = t15;
  const fetching = trait1Fetching || trait2Fetching;
  let t16;
  if ($[17] !== trait1Error || $[18] !== trait2Error) {
    t16 = [trait1Error, trait2Error].filter(Boolean);
    $[17] = trait1Error;
    $[18] = trait2Error;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const errors = t16;
  const error = errors.length > 0 ? errors[0] : undefined;
  let t17;
  if ($[20] !== attributes || $[21] !== error || $[22] !== fetching) {
    t17 = {
      attributes,
      fetching,
      error
    };
    $[20] = attributes;
    $[21] = error;
    $[22] = fetching;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  return t17;
}